import SearchParamsBase from '../../../Elements/SearchParamsBase';
import OfficeHelper from '../../../Helpers/ModelHelpers/OfficeHelper';
import AuthService from '../../../Services/authService';

export default class EvaluatorCountReportSearchParams extends SearchParamsBase {
  static saveType = 'EvaluatorCountReportSearchParams';
  initialize() {
    this.OfficeIds = EvaluatorCountReportSearchParams.getUserOffice();
    this.CountryCodes = [];
    this.GroupBy = ['country', 'state', 'city'];
  }

  static getUserOffice() {
    const user = AuthService.getInstance().GetLoggedInUser();
    return OfficeHelper.GetDefaultOfficeIds(user.officeId);
  }
}
